<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              <h2>Gestión de Citas</h2>
            </v-card-title>
            <v-card-text>

              
              <div v-if="isDoctor" class="mb-4">
                <h2 class="primary--text">
                  <v-icon large color="primary" class="mr-2">mdi-doctor</v-icon>
                  Agenda de: {{ doctorName }}
                </h2>
                <div v-if="!selected && !loadding" class="error--text caption">
                    (No se encontró agenda vinculada)
                </div>
              </div>

              <v-select
                v-if="!isDoctor"
                v-model="selected"
                :items="nombres"
                item-text="text"
                item-value="value"
                return-object
                label="Seleccionar Profesional"
                placeholder="Seleccione un profesional"
                outlined
                clearable
                @input="getAppointments"
              />
              
              <v-btn 
                @click="handlerSobreturno" 
                color="primary" 
                class="mt-3 mr-3"
                :disabled="!selected"
              >
                <v-icon left>mdi-plus</v-icon>
                Agregar Sobreturno
              </v-btn>
              
              <!-- Filtros por estado -->
              <v-chip-group
                v-model="filtroEstado"
                active-class="primary--text"
                mandatory
                class="mt-3"
              >
                <v-chip value="todos">Todos</v-chip>
                <v-chip value="free">Libres</v-chip>
                <v-chip value="confirmed">Confirmados</v-chip>
                <v-chip value="checked_in">En Espera</v-chip>
                <v-chip value="done">Terminados</v-chip>
              </v-chip-group>
              
              <div v-if="loadding" class="mt-4">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                Cargando turnos...
              </div>
              
              <div v-if="turnosFiltrados.length > 0 && !loadding" class="mt-4">
                <h3>{{ tituloTurnos }} ({{ turnosFiltrados.length }})</h3>
                <v-data-table
                  :headers="headers"
                  :items="turnosFiltrados"
                  class="elevation-1"
                  :items-per-page="10"
                >
                  <template v-slot:item.start="{ item }">
                    {{ formatDateTime(item.start) }}
                  </template>
                  
                  <template v-slot:item.state="{ item }">
                    <v-chip :color="getStateColor(item.state)" small>
                      {{ getStateText(item.state) }}
                    </v-chip>
                  </template>
                  
                  <template v-slot:item.patient_name="{ item }">
                    <span v-if="item.state === 'free'" class="grey--text">
                      Disponible
                    </span>
                    <span v-else>
                      <strong>{{ getPatientName(item) }}</strong>
                    </span>
                  </template>
                  
                  <template v-slot:item.tipo_visita="{ item }">
                    <span v-if="item.state !== 'free'">
                      {{ item.tipo_visita || item.visit_type || 'Consulta' }}
                    </span>
                    <span v-else class="grey--text">-</span>
                  </template>
                  
                  <template v-slot:item.telefono="{ item }">
                    <span v-if="item.state !== 'free' && getPatientPhone(item)">
                      {{ getPatientPhone(item) }}
                      <v-btn 
                        icon 
                        small 
                        color="green" 
                        @click="openWhatsApp(getPatientPhone(item))"
                        title="Contactar por WhatsApp"
                      >
                        <v-icon small>mdi-whatsapp</v-icon>
                      </v-btn>
                    </span>
                    <span v-else class="grey--text">-</span>
                  </template>
                  
                  <template v-slot:item.obra_social="{ item }">
                    <span v-if="item.state !== 'free'">
                      {{ getObraSocial(item) || '-' }}
                    </span>
                    <span v-else class="grey--text">-</span>
                  </template>
                  
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      v-if="item.state !== 'free' && isDoctor"
                      small
                      color="purple"
                      class="white--text mr-1"
                      @click="irAHistoriaClinica(item)"
                    >
                      <v-icon small left>mdi-file-document-edit</v-icon>
                      Historia
                    </v-btn>

                    <v-btn
                      v-if="item.state === 'free'"
                      small
                      color="success"
                      @click="reservarTurno(item)"
                    >
                      <v-icon small left>mdi-calendar-check</v-icon>
                      Reservar
                    </v-btn>
                    
                    <v-btn
                      v-else-if="item.state === 'confirmed'"
                      small
                      color="orange"
                      @click="cambiarEstado(item, 'checked_in')"
                    >
                      <v-icon small left>mdi-clock</v-icon>
                      En Espera
                    </v-btn>
                    
                    <v-btn
                      v-else-if="item.state === 'checked_in'"
                      small
                      color="blue"
                      @click="cambiarEstado(item, 'done')"
                    >
                      <v-icon small left>mdi-check</v-icon>
                      Terminar
                    </v-btn>
                    
                    <v-btn
                      v-if="item.state !== 'done'"
                      small
                      color="red"
                      text
                      @click="cancelarTurno(item)"
                    >
                      <v-icon small>mdi-cancel</v-icon>
                      Cancelar
                    </v-btn>
                  </template>
                </v-data-table>
              </div>
              
              <div v-if="turnosFiltrados.length === 0 && !loadding && selected" class="mt-4">
                <v-alert type="info">
                  {{ mensajeNoTurnos }}
                </v-alert>
              </div>
              
              <!-- Dialog para sobreturno - Responsive -->
              <v-dialog 
                v-model="sobreTurno" 
                :max-width="$vuetify.breakpoint.smAndDown ? '95%' : '700px'" 
                persistent
                scrollable
              >
                <v-card class="sobreturno-card">
                  <v-card-title class="primary white--text py-4">
                    <v-icon left color="white">mdi-calendar-plus</v-icon>
                    <span>Crear Sobreturno</span>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="cancelarSobreturno">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  
                  <v-card-text class="pa-4 pa-md-6">
                    <!-- Datos del paciente -->
                    <div class="section-title mb-3">
                      <v-icon left small color="primary">mdi-account</v-icon>
                      <span class="font-weight-bold">Datos del Paciente</span>
                    </div>
                    
                    <v-row dense>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="account_info.name"
                          label="Nombre"
                          placeholder="Ingrese nombre"
                          outlined
                          dense
                          required
                          :rules="[v => !!v || 'Requerido']"
                        >
                          <template v-slot:prepend-inner>
                            <v-icon small>mdi-account</v-icon>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="account_info.lastname"
                          label="Apellido"
                          placeholder="Ingrese apellido"
                          outlined
                          dense
                          required
                          :rules="[v => !!v || 'Requerido']"
                        >
                          <template v-slot:prepend-inner>
                            <v-icon small>mdi-account-outline</v-icon>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <div class="d-flex align-center">
                          <v-text-field
                            v-model="account_info.dni"
                            label="DNI"
                            placeholder="Ej: 12345678"
                            outlined
                            dense
                            required
                            :rules="[v => !!v || 'Requerido']"
                            @keydown.enter.prevent="searchPaciente"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon small>mdi-card-account-details</v-icon>
                            </template>
                          </v-text-field>
                          <v-btn 
                            color="info" 
                            small 
                            class="ml-2 mb-6" 
                            @click="searchPaciente"
                            :loading="searchingPaciente"
                          >
                            <v-icon>mdi-magnify</v-icon>
                          </v-btn>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="account_info.telefono"
                          label="Teléfono"
                          placeholder="Ej: 11 1234-5678"
                          outlined
                          dense
                        >
                          <template v-slot:prepend-inner>
                            <v-icon small>mdi-phone</v-icon>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="account_info.mail"
                          label="Email (opcional)"
                          placeholder="ejemplo@email.com"
                          outlined
                          dense
                          type="email"
                        >
                          <template v-slot:prepend-inner>
                            <v-icon small>mdi-email</v-icon>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-select
                          v-model="account_info.tipoDeConsulta"
                          :items="tiposConsulta"
                          item-text="name"
                          item-value="value"
                          label="Tipo de Consulta"
                          outlined
                          dense
                          prepend-inner-icon="mdi-stethoscope"
                          @change="onTipoConsultaChange"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-select
                          v-model="account_info.insuranse"
                          :items="insuranseOptions"
                          item-text="name"
                          item-value="value"
                          label="Obra Social"
                          outlined
                          dense
                          clearable
                        >
                          <template v-slot:selection="{ item }">
                            {{ item.name }}
                          </template>
                          <template v-slot:item="{ item }">
                            {{ item.name }}
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="account_info.affiliate_number"
                          label="Nº de Afiliado"
                          placeholder="Número de carnet"
                          outlined
                          dense
                        >
                          <template v-slot:prepend-inner>
                            <v-icon small>mdi-card-account-details-outline</v-icon>
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    
                    <v-divider class="my-4"></v-divider>
                    
                    <!-- Fecha y Hora - Versión compacta -->
                    <div class="section-title mb-3">
                      <v-icon left small color="primary">mdi-clock</v-icon>
                      <span class="font-weight-bold">Fecha y Hora del Turno</span>
                    </div>
                    
                    <v-row dense>
                      <!-- Selector de Fecha -->
                      <v-col cols="12" sm="6">
                        <v-menu
                          v-model="menuFecha"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="fechaFormateada"
                              label="Fecha"
                              readonly
                              outlined
                              dense
                              v-bind="attrs"
                              v-on="on"
                            >
                              <template v-slot:prepend-inner>
                                <v-icon small color="primary">mdi-calendar</v-icon>
                              </template>
                              <template v-slot:append>
                                <v-icon small>mdi-menu-down</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <v-date-picker 
                            v-model="date" 
                            :min="minDate"
                            locale="es"
                            @input="menuFecha = false"
                            no-title
                            scrollable
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      
                      <!-- Selector de Hora -->
                      <v-col cols="12" sm="6">
                        <v-menu
                          v-model="menuHora"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="picker"
                              label="Hora"
                              readonly
                              outlined
                              dense
                              v-bind="attrs"
                              v-on="on"
                              placeholder="Seleccione hora"
                            >
                              <template v-slot:prepend-inner>
                                <v-icon small color="primary">mdi-clock-outline</v-icon>
                              </template>
                              <template v-slot:append>
                                <v-icon small>mdi-menu-down</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <v-time-picker 
                            v-model="picker" 
                            format="24hr"
                            :allowed-hours="allowedHours"
                            :allowed-minutes="allowedMinutes"
                            @click:minute="menuHora = false"
                            scrollable
                          ></v-time-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    
                    <!-- Resumen de selección -->
                    <v-alert 
                      v-if="date && picker" 
                      type="success" 
                      dense 
                      text
                      class="mt-2"
                    >
                      <div class="d-flex align-center">
                        <v-icon left small color="success">mdi-check-circle</v-icon>
                        <span>Turno: <strong>{{ formatFechaHoraResumen }}</strong></span>
                      </div>
                    </v-alert>
                  </v-card-text>
                  
                  <v-divider></v-divider>
                  
                  <v-card-actions class="pa-4">
                    <v-btn 
                      text 
                      @click="cancelarSobreturno"
                      class="px-4"
                    >
                      <v-icon left>mdi-close</v-icon>
                      Cancelar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn 
                      @click="crearTurno" 
                      color="primary" 
                      :disabled="!validarSobreturno"
                      :loading="creandoSobreturno"
                      class="px-6"
                    >
                      <v-icon left>mdi-check</v-icon>
                      Crear Sobreturno
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              
              <!-- Dialog Check-In (Estilo Sobreturno) -->
              <v-dialog 
                v-model="dialogCheckIn" 
                :max-width="$vuetify.breakpoint.smAndDown ? '95%' : '800px'" 
                persistent
                scrollable
              >
                <v-card class="sobreturno-card">
                  <v-card-title class="primary white--text py-4">
                    <v-icon left color="white">mdi-account-check</v-icon>
                    <span>Confirmar Ingreso (Check-In)</span>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="cancelarCheckIn">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  
                  <v-card-text class="pa-4 pa-md-6">
                    <div class="mb-4">
                        <v-alert type="info" text dense icon="mdi-information">
                            Verifique y actualice los datos del paciente antes de confirmar su ingreso a sala de espera.
                        </v-alert>
                    </div>

                    <!-- Datos Personales -->
                    <div class="section-title mb-3">
                      <v-icon left small color="primary">mdi-account</v-icon>
                      <span class="font-weight-bold">Datos Personales</span>
                    </div>
                    
                    <v-row dense>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="account_info.name"
                          label="Nombre"
                          outlined dense required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="account_info.lastname"
                          label="Apellido"
                          outlined dense required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="account_info.dni"
                          label="DNI"
                          outlined dense required readonly
                          hint="El DNI no se puede editar aquí"
                          persistent-hint
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                            <v-select
                                v-model="account_info.gender"
                                :items="goptions"
                                label="Género"
                                outlined dense
                            ></v-select>
                      </v-col>
                      <v-col cols="12" sm="6">
                           <v-text-field 
                                type="date" 
                                v-model="account_info.dob"
                                label="Fecha de Nacimiento"
                                outlined dense
                           />
                      </v-col>
                    </v-row>

                    <v-divider class="my-4"></v-divider>

                    <!-- Contacto y Cobertura -->
                    <div class="section-title mb-3">
                      <v-icon left small color="primary">mdi-card-account-details</v-icon>
                      <span class="font-weight-bold">Contacto y Cobertura</span>
                    </div>

                    <v-row dense>
                        <v-col cols="12" sm="6">
                            <v-text-field
                            v-model="account_info.telefono"
                            label="Teléfono"
                            outlined dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field
                            v-model="account_info.mail"
                            label="Email"
                            outlined dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select
                                v-model="account_info.insuranse"
                                :items="insuranseOptions"
                                item-text="name"
                                item-value="value"
                                label="Obra Social"
                                outlined dense
                            >
                                <template v-slot:selection="{ item }">
                                    {{ item.name }}
                                </template>
                                <template v-slot:item="{ item }">
                                    {{ item.name }}
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                    
                    <v-divider class="my-4"></v-divider>

                    <!-- Dirección -->
                     <div class="section-title mb-3">
                      <v-icon left small color="primary">mdi-map-marker</v-icon>
                      <span class="font-weight-bold">Dirección</span>
                    </div>
                     <v-row dense>
                        <v-col cols="12" sm="6">
                            <v-text-field
                            v-model="account_info.street"
                            label="Calle / Dirección"
                            outlined dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field
                            v-model="account_info.city"
                            label="Ciudad"
                            outlined dense
                            ></v-text-field>
                        </v-col>
                         <v-col cols="12" sm="6">
                            <v-select
                                v-model="account_info.subdivision"
                                :items="provincias"
                                item-text="name"
                                item-value="value"
                                label="Provincia"
                                outlined dense
                            ></v-select>
                        </v-col>
                     </v-row>

                  </v-card-text>
                  
                  <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn text @click="cancelarCheckIn">Cancelar</v-btn>
                    <v-btn 
                      @click="confirmarCheckIn" 
                      color="primary" 
                      :loading="checkInLoading"
                      class="px-6"
                    >
                      <v-icon left>mdi-check</v-icon>
                      Confirmar Ingreso
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <!-- Dialog para Cancelación de Turno -->
              <v-dialog v-model="dialogCancelar" max-width="500px">
                <v-card>
                  <v-card-title class="headline error white--text">
                    Cancelar Turno
                  </v-card-title>

                  <v-card-text class="pt-4">
                    <p class="subtitle-1">Seleccione el motivo de la cancelación:</p>
                    <v-radio-group v-model="selectedCancellationState">
                      <v-radio
                        v-for="option in cancellationOptions"
                        :key="option.value"
                        :label="option.text"
                        :value="option.value"
                      ></v-radio>
                    </v-radio-group>
                    
                    <v-alert
                      v-if="selectedCancellationState === 'center_cancelled'"
                      type="warning"
                      dense
                      text
                      class="mt-2"
                    >
                      El turno quedará bloqueado (NO disponible para otros pacientes).
                    </v-alert>
                     <v-alert
                      v-if="selectedCancellationState === 'user_cancelled'"
                      type="info"
                      dense
                      text
                      class="mt-2"
                    >
                      El turno quedará LIBRE (Disponible para otros pacientes).
                    </v-alert>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="dialogCancelar = false">
                      Cerrar
                    </v-btn>
                    <v-btn 
                      color="error" 
                      @click="confirmarCancelacion"
                      :disabled="!selectedCancellationState"
                    >
                      Confirmar Cancelación
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <!-- Dialog para reservar turno (Estilo Sobreturno) -->
              <v-dialog 
                v-model="dialogReserva" 
                :max-width="$vuetify.breakpoint.smAndDown ? '95%' : '800px'"
                persistent
                scrollable
              >
                <v-card class="sobreturno-card">
                  <v-card-title class="success white--text py-4">
                    <v-icon left color="white">mdi-calendar-check</v-icon>
                    <span>Reservar Turno</span>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="cancelarReserva">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  
                  <v-card-text class="pa-4 pa-md-6">
                    <!-- Info del turno seleccionado -->
                    <div v-if="turnoSeleccionado" class="mb-4 pa-3 grey lighten-4 rounded">
                        <div class="d-flex align-center mb-1">
                            <v-icon small color="primary" class="mr-2">mdi-clock-outline</v-icon>
                            <strong>{{ formatDateTime(turnoSeleccionado.start) }}</strong>
                        </div>
                         <div class="d-flex align-center">
                            <v-icon small color="primary" class="mr-2">mdi-doctor</v-icon>
                            <span>{{ getProfessionalName(turnoSeleccionado.professional_id) }}</span>
                        </div>
                    </div>

                    <!-- Datos del Paciente (Búsqueda + Formulario) -->
                    <div class="section-title mb-3">
                      <v-icon left small color="primary">mdi-account</v-icon>
                      <span class="font-weight-bold">Datos del Paciente</span>
                    </div>

                    <v-row dense>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="account_info.dni"
                          label="DNI"
                          placeholder="Ingrese DNI y presione ENTER"
                          outlined dense required
                          append-outer-icon="mdi-magnify"
                          @click:append-outer="searchPaciente"
                          @keydown.enter.prevent="searchPaciente"
                          :loading="searchingPaciente"
                        ></v-text-field>
                      </v-col>
                       <v-col cols="12" sm="6">
                           <!-- Espaciador o botón explícito si se prefiere -->
                             <v-btn 
                                color="info" 
                                small 
                                text
                                @click="searchPaciente"
                                :disabled="!account_info.dni"
                              >
                                Buscar Paciente
                              </v-btn>
                       </v-col>

                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="account_info.name"
                          label="Nombre"
                          outlined dense required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="account_info.lastname"
                          label="Apellido"
                          outlined dense required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                            <v-select
                                v-model="account_info.gender"
                                :items="goptions"
                                label="Género"
                                outlined dense
                            ></v-select>
                      </v-col>
                      <v-col cols="12" sm="6">
                           <v-text-field 
                                type="date" 
                                v-model="account_info.dob"
                                label="Fecha de Nacimiento"
                                outlined dense
                           />
                      </v-col>
                      
                      <v-col cols="12">
                        <v-select
                          v-model="account_info.tipoDeConsulta"
                          :items="tiposConsulta"
                          item-text="name"
                          item-value="value"
                          label="Tipo de Consulta"
                          outlined dense
                          required
                          prepend-inner-icon="mdi-stethoscope"
                          @change="onTipoConsultaChange"
                        ></v-select>
                      </v-col>
                    </v-row>

                    <v-divider class="my-4"></v-divider>

                    <div class="section-title mb-3">
                      <v-icon left small color="primary">mdi-card-account-details</v-icon>
                      <span class="font-weight-bold">Contacto y Cobertura</span>
                    </div>

                     <v-row dense>
                        <v-col cols="12" sm="6">
                            <v-text-field
                            v-model="account_info.telefono"
                            label="Teléfono"
                            outlined dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field
                            v-model="account_info.mail"
                            label="Email"
                            outlined dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select
                                v-model="account_info.insuranse"
                                :items="insuranseOptions"
                                item-text="name"
                                item-value="value"
                                label="Obra Social"
                                outlined dense
                            >
                                <template v-slot:selection="{ item }">
                                    {{ item.name }}
                                </template>
                                <template v-slot:item="{ item }">
                                    {{ item.name }}
                                </template>
                            </v-select>
                        </v-col>
                        <v-col cols="12" sm="6">
                             <v-text-field
                                v-model="account_info.affiliate_number"
                                label="Nº de Afiliado"
                                outlined dense
                                placeholder="Número de carnet"
                             ></v-text-field>
                        </v-col>
                    </v-row>
                    
                    <v-divider class="my-4"></v-divider>
                    
                     <div class="section-title mb-3">
                      <v-icon left small color="primary">mdi-map-marker</v-icon>
                      <span class="font-weight-bold">Dirección</span>
                    </div>
                     <v-row dense>
                        <v-col cols="12" sm="6">
                            <v-text-field
                            v-model="account_info.street"
                            label="Calle / Dirección"
                            outlined dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field
                            v-model="account_info.city"
                            label="Ciudad"
                            outlined dense
                            ></v-text-field>
                        </v-col>
                         <v-col cols="12" sm="6">
                            <v-select
                                v-model="account_info.subdivision"
                                :items="provincias"
                                item-text="name"
                                item-value="value"
                                label="Provincia"
                                outlined dense
                            ></v-select>
                        </v-col>
                     </v-row>

                  </v-card-text>
                  <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn text @click="cancelarReserva">Cancelar</v-btn>
                    <v-btn 
                      @click="confirmarReserva" 
                      color="success" 
                      :loading="checkInLoading" 
                      class="px-6"
                      :disabled="!account_info.dni || !account_info.name || !account_info.lastname"
                    >
                      <v-icon left>mdi-check</v-icon>
                      Confirmar Reserva
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              
              <!-- PacienteCard para buscar/crear paciente -->
              <PacienteCard 
                :dialog="dialog2" 
                :paciente_id="paciente_id" 
                @dataPaciente="onDataPaciente" 
                @cambiarEstado="onPacienteConfirmed"
                @close="onClosePacienteCard" 
              />

              <v-dialog v-model="dialogNuevoTipoConsulta" max-width="480">
                <v-card>
                  <v-card-title class="headline">Agregar tipo de consulta</v-card-title>
                  <v-card-text>
                    <v-text-field
                      v-model="nuevoTipoConsultaNombre"
                      label="Nuevo tipo de consulta"
                      outlined
                      dense
                      autofocus
                      @keyup.enter="guardarNuevoTipoConsulta"
                    />
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="cancelarNuevoTipoConsulta">Cancelar</v-btn>
                    <v-btn color="primary" :loading="guardandoNuevoTipoConsulta" @click="guardarNuevoTipoConsulta">
                      Guardar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { getProfesionales, decodeProfesional, getPacienteUnificado, updatePaciente } from '@/services/monolito'
import { 
  getTodosTurnos, 
  reservarTurnoSecretaria, 
  cambiarEstadoTurno, 
  crearSobreturno,
  getTurnosDoctor,
  getPracticas,
  createPractica
} from '@/services/appointmentsApi'
import { get_profesional_id, initial_data } from '@/services/utils'
import PacienteCard from "@/components/PacienteCard.vue"

function createEmptyAccountInfo() {
  return {
    gender: 'MASCULINO',
    name: '',
    password: '',
    lastname: '',
    dni: '',
    roles: ['end_user'],
    dob: '',
    active: true,
    city: '',
    street: '',
    subdivision: '',
    insuranse: '',
    affiliate_number: '',
    telefono: '',
    mail: '',
    tipoDeConsulta: 'Consulta de seguimiento'
  }
}

export default {
  name: "CitasSimple",
  components: {
    PacienteCard
  },
  data() {
    // Fecha y hora actual para valores por defecto
    const now = new Date();
    // Fix: Use local date for defaultDate instead of UTC to avoid "tomorrow" bug late in the day
    const defaultDate = new Date(now.getTime() - (now.getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
    
    // Calcular hora redondeada a 15 min
    let h = now.getHours();
    let m = Math.ceil(now.getMinutes() / 15) * 15;
    
    if (m === 60) {
        m = 0;
        h += 1;
        if (h === 24) h = 0;
    }
    
    const defaultTime = h.toString().padStart(2, '0') + ':' + m.toString().padStart(2, '0');
    
    return {
      loadding: false,
      selected: null,
      profesional: [],
      nombres: [],
      appointments: [],
      sobreTurno: false,
      date: defaultDate,
      picker: defaultTime,
      filtroEstado: 'todos',
      dialogReserva: false,
      turnoSeleccionado: null,
      paciente_id: null,
      dialog2: false,
      tabSobreturno: 0,
      creandoSobreturno: false,
      menuFecha: false,
      menuHora: false,
      // Formulario para sobreturno
      pacienteForm: {
        nombre: '',
        apellido: '',
        dni: '',
        telefono: '',
        email: ''
      },
      account_info: createEmptyAccountInfo(),
      headers: [
        { text: 'Fecha/Hora', value: 'start' },
        { text: 'Estado', value: 'state' },
        { text: 'Paciente', value: 'patient_name' },
        { text: 'Tipo de Consulta', value: 'tipo_visita' },
        { text: 'Teléfono', value: 'telefono' },
        { text: 'Obra Social', value: 'obra_social' },
        { text: 'Acciones', value: 'actions', sortable: false }
      ],
      searchingPaciente: false,
      pendingStateChange: null, // Para guardar el cambio de estado pendiente
      
      // Dialog Check-in
      dialogCheckIn: false,
      checkInLoading: false,
      insuranseOptions: [],
      provincias: [],
      goptions: [
          { text: 'MASCULINO', value: 'm' },
          { text: 'FEMENINO', value: 'f' }
      ],
        tiposConsulta: [],
        cargandoTiposConsulta: false,
        dialogNuevoTipoConsulta: false,
        guardandoNuevoTipoConsulta: false,
        nuevoTipoConsultaNombre: '',
        tipoConsultaPrevio: 'Consulta de seguimiento',
      dialogCancelar: false,
      selectedCancellationState: 'user_cancelled',
      cancellationOptions: [
          { text: 'Cancelado por el paciente (Libera turno)', value: 'user_cancelled' },
          { text: 'Cancelado por el centro (No libera turno)', value: 'center_cancelled' },
          { text: 'No se presentó (Ausente)', value: 'missed' }
      ],
      turnoParaCancelar: null,
    }
  },

  computed: {
    // ... existing computed properties ...
    isDoctor() {
        // 1. Check user_profile (Primary source)
        const userProfile = this.$store.state.user_profile;
        if (userProfile && userProfile.roles && userProfile.roles.length > 0) {
            const profileRole = userProfile.roles[0].toLowerCase();
            return profileRole === 'doctor' || profileRole === 'medico';
        }

        // 2. Check credentials.role (Fallback)
        const credRoles = this.$store.state.credentials.role;
        
        if (!credRoles) return false;
        
        if (Array.isArray(credRoles)) {
            return credRoles.some(r => r === 'doctor' || r === 'medico');
        }
        
        return credRoles === 'doctor' || credRoles === 'medico';
    },

    minDate() {
      const now = new Date();
      return new Date(now.getTime() - (now.getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
    },

    fechaFormateada() {
      if (!this.date) return '';
      const fecha = new Date(this.date + 'T00:00:00');
      return fecha.toLocaleDateString('es-AR', {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    },

    allowedHours() {
      return function(hour) { return hour >= 8 && hour <= 20; };
    },

    allowedMinutes() {
      return function(minute) { return minute % 15 === 0; };
    },

    formatFechaHoraResumen() {
      if (!this.date || !this.picker) return '';
      const fecha = new Date(this.date + 'T' + this.picker);
      return fecha.toLocaleString('es-AR', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    
    turnosFiltrados() {
      if (this.filtroEstado === 'todos') {
        return this.appointments
      }
      return this.appointments.filter(appointment => appointment.state === this.filtroEstado)
    },
    
    tituloTurnos() {
      switch(this.filtroEstado) {
        case 'free': return 'Turnos Libres'
        case 'confirmed': return 'Turnos Confirmados'
        case 'checked_in': return 'Turnos en Espera'
        case 'done': return 'Turnos Terminados'
        default: return 'Todos los Turnos'
      }
    },
    
    mensajeNoTurnos() {
      switch(this.filtroEstado) {
        case 'free': return 'No hay turnos libres para este profesional'
        case 'confirmed': return 'No hay turnos confirmados para este profesional'
        case 'checked_in': return 'No hay turnos en espera para este profesional'
        case 'done': return 'No hay turnos terminados para este profesional'
        default: return 'No hay turnos disponibles para este profesional'
      }
    },
    
    // ... existing computed properties ...
    doctorName() {
        if (this.selected) return this.selected.text || this.selected.name;
        
        const profile = this.$store.state.user_profile;
        if (profile) {
            // Prioridad: Party Name > Rec Name > Username
            if (profile.party && profile.party.name) {
                return profile.party.name + (profile.party.lastname ? ' ' + profile.party.lastname : '');
            }
            if (profile.party_name) return profile.party_name;
            if (profile.rec_name) return profile.rec_name;
            
            // Validate that name is not just a number (ID)
            if (profile.name && isNaN(profile.name)) return profile.name;
        }
        
        return this.$store.state.credentials.name || 'Desconocido';
    },

    validarSobreturno() {
      return this.account_info.name && 
             this.account_info.lastname && 
             this.account_info.dni && 
             this.date && 
             this.picker
    }
  },
  
  watch: {
    selected(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.getAppointments()
      }
    },
    
    account_info: {
      handler(newVal, oldVal) {
      },
      deep: true
    }
  },
  
  created() {
    this.initializeAccountInfo()
    this.getProfesional()
    this.loadInitialData()
    this.loadTiposConsulta()
  },
  
  methods: {
    async loadInitialData() {
        try {
            const data = await initial_data();
            this.insuranseOptions = data.insuranse || [];
            this.provincias = data.provincias || [];
        } catch (error) {
            console.error('❌ Error loading initial data:', error);
        }
    },

    normalizeTipoConsultaOption(value) {
      const nombre = (value || '').toString().trim()
      if (!nombre) return null
      return { name: nombre, value: nombre }
    },

    async loadTiposConsulta() {
      this.cargandoTiposConsulta = true
      try {
        const practicas = await getPracticas('tipo_visita')
        const defaults = [
          'Consulta de seguimiento',
          '1era vez con ECG',
          'Ecocardiograma doppler color',
          'Ecodoppler vao de cuello',
          'Ergometria',
          'Prequirurgico'
        ]

        const nombresBackend = Array.isArray(practicas)
          ? practicas
              .filter(item => item && item.name)
              .map(item => item.name)
          : []

        const nombres = [...nombresBackend, ...defaults]
        const unique = []
        const seen = new Set()

        nombres.forEach((item) => {
          const normalized = (item || '').toString().trim()
          if (!normalized) return
          const key = normalized.toLowerCase()
          if (seen.has(key)) return
          seen.add(key)
          unique.push(this.normalizeTipoConsultaOption(normalized))
        })

        if (this.account_info?.tipoDeConsulta) {
          const actual = this.account_info.tipoDeConsulta.trim()
          if (actual && !seen.has(actual.toLowerCase())) {
            unique.unshift(this.normalizeTipoConsultaOption(actual))
          }
        }

        this.tiposConsulta = [
          ...unique.filter(Boolean),
          { name: '+ Agregar nuevo tipo...', value: '__add_new_tipo_consulta__' }
        ]

        if (!this.account_info.tipoDeConsulta && unique.length > 0) {
          this.account_info.tipoDeConsulta = unique[0].value
        }
        this.tipoConsultaPrevio = this.account_info.tipoDeConsulta || 'Consulta de seguimiento'
      } catch (error) {
        this.tiposConsulta = [
          this.normalizeTipoConsultaOption('Consulta de seguimiento'),
          { name: '+ Agregar nuevo tipo...', value: '__add_new_tipo_consulta__' }
        ].filter(Boolean)
      } finally {
        this.cargandoTiposConsulta = false
      }
    },

    onTipoConsultaChange(value) {
      if (value === '__add_new_tipo_consulta__') {
        this.abrirDialogNuevoTipoConsulta()
        return
      }

      if (value) {
        this.tipoConsultaPrevio = value
      }
    },

    abrirDialogNuevoTipoConsulta() {
      this.dialogNuevoTipoConsulta = true
      this.nuevoTipoConsultaNombre = ''

      if (this.account_info.tipoDeConsulta === '__add_new_tipo_consulta__') {
        this.account_info.tipoDeConsulta = this.tipoConsultaPrevio || 'Consulta de seguimiento'
      }
    },

    cancelarNuevoTipoConsulta() {
      this.dialogNuevoTipoConsulta = false
      this.nuevoTipoConsultaNombre = ''
      this.account_info.tipoDeConsulta = this.tipoConsultaPrevio || 'Consulta de seguimiento'
    },

    async guardarNuevoTipoConsulta() {
      const nombre = (this.nuevoTipoConsultaNombre || '').trim()
      if (!nombre) {
        this.$store.commit('showSnackbar', { text: 'Ingrese un nombre para el tipo de consulta', color: 'warning' })
        return
      }

      const existe = this.tiposConsulta.find(
        item => item && item.value !== '__add_new_tipo_consulta__' && item.value.toLowerCase() === nombre.toLowerCase()
      )

      if (existe) {
        this.account_info.tipoDeConsulta = existe.value
        this.tipoConsultaPrevio = existe.value
        this.dialogNuevoTipoConsulta = false
        this.nuevoTipoConsultaNombre = ''
        this.$store.commit('showSnackbar', { text: 'Ese tipo de consulta ya existe y fue seleccionado', color: 'info' })
        return
      }

      this.guardandoNuevoTipoConsulta = true
      try {
        const result = await createPractica({
          name: nombre,
          categoria: 'tipo_visita'
        })

        if (!result.success) {
          this.$store.commit('showSnackbar', { text: 'No se pudo guardar el nuevo tipo de consulta', color: 'error' })
          return
        }

        const createdName = (result.data && result.data.name ? result.data.name : nombre).trim()
        const nuevaOpcion = this.normalizeTipoConsultaOption(createdName)
        const addItem = this.tiposConsulta.find(item => item.value === '__add_new_tipo_consulta__')
        const baseItems = this.tiposConsulta.filter(item => item.value !== '__add_new_tipo_consulta__')

        this.tiposConsulta = [
          ...baseItems,
          nuevaOpcion,
          addItem || { name: '+ Agregar nuevo tipo...', value: '__add_new_tipo_consulta__' }
        ]

        this.account_info.tipoDeConsulta = nuevaOpcion.value
        this.tipoConsultaPrevio = nuevaOpcion.value
        this.dialogNuevoTipoConsulta = false
        this.nuevoTipoConsultaNombre = ''

        this.$store.commit('showSnackbar', {
          text: result.localFallback
            ? 'Tipo agregado. Se guardó localmente en este navegador.'
            : 'Tipo de consulta agregado correctamente',
          color: result.localFallback ? 'warning' : 'success'
        })
      } catch (error) {
        this.$store.commit('showSnackbar', { text: 'Error al guardar el nuevo tipo de consulta', color: 'error' })
      } finally {
        this.guardandoNuevoTipoConsulta = false
      }
    },

    initializeAccountInfo() {
      // Inicializar datos de cuenta desde el store si están disponibles
      const storeAccount = this.$store.getters.getAccount
      if (storeAccount) {
        Object.assign(this.account_info, storeAccount)
      }
    },

    async getProfesional() {
      try {
        const profesionalData = await getProfesionales()
        
        if (!profesionalData || profesionalData.length === 0) {
          this.profesional = []
          this.nombres = []
          return
        }
        
        this.profesional = profesionalData
        this.nombres = decodeProfesional(this.profesional)
        
        // AUTO-SELECT FOR DOCTORS
        if (this.isDoctor) {
            // Priority: Name from profile, then credentials
            let myName = '';
            const userProfile = this.$store.state.user_profile;
            if (userProfile) {
                // Priority: Party name > rec_name > name
                if (userProfile.party && userProfile.party.name) {
                    myName = userProfile.party.name + (userProfile.party.lastname ? ' ' + userProfile.party.lastname : '');
                }
                else if (userProfile.rec_name) myName = userProfile.rec_name;
                else if (userProfile.name && isNaN(userProfile.name)) myName = userProfile.name;
            }
            
            if (!myName && this.$store.state.credentials.name) {
                myName = this.$store.state.credentials.name;
            }
            
            if (myName) myName = myName.toUpperCase();
            
            if (myName) {
                // 1. Try exact match
                let found = this.nombres.find(n => n.text.toUpperCase() === myName);
                
                // 2. Try contains match
                if (!found) {
                     found = this.nombres.find(n => n.text.toUpperCase().includes(myName));
                }
                
                // 3. Try reverse match (if myName is "Name Lastname" and list has "Lastname Name")
                if (!found && myName.includes(' ')) {
                    const parts = myName.split(' ');
                    if (parts.length >= 2) {
                         const reverseName = parts[1] + ' ' + parts[0];
                         found = this.nombres.find(n => n.text.toUpperCase().includes(reverseName));
                    }
                }

                if (found) {
                    this.selected = found;
                    this.getAppointments();
                } else {
                    this.$store.commit('showSnackbar', { 
                        text: `No se encontró agenda para el usuario: ${myName}`, 
                        color: 'warning', 
                        timeout: 5000 
                    });
                }
            }
        }
        
      } catch (error) {
        this.profesional = []
        this.nombres = []
      }
    },

    async irAHistoriaClinica(item = null) {
      if (!item) return;
      
      this.$router.push({ 
          name: 'historia-clinica', 
          params: { event: item } 
      });
    },

    async getAppointments() {
      
      if (!this.selected) {
        this.appointments = []
        return
      }

      this.loadding = true
      
      try {
        let idProfesional = get_profesional_id(this.selected, this.profesional, this.nombres)
        
        if (!idProfesional) {
          this.appointments = []
          return
        }
        
        // Determinar si usar API de doctor (dato enriquecido) o generico
        let useDoctorApi = false;
        if (this.isDoctor) {
             const userProfile = this.$store.state.user_profile;
             // Si el ID seleccionado coincide con mi ID de profesional
             if (userProfile && userProfile.professional_id && userProfile.professional_id == idProfesional) {
                 useDoctorApi = true;
             }
        }
        
        if (useDoctorApi) {
            // Usar API de doctor que devuelve nombres correctos
            const citas = await getTurnosDoctor(false);
            // Mapear para asegurar compatibilidad si hace falta
            this.appointments = this.normalizeAppointments(citas);
        } else {
            // Usar el API generico (legacy/secretaria)
            // Usar el API generico (legacy/secretaria)
            const result = await getTodosTurnos(idProfesional)
            if (result && result.citas) {
              this.appointments = this.normalizeAppointments(result.citas)
            } else {
              this.appointments = []
            }
        }

      } catch (error) {
        this.appointments = []
      } finally {
        this.loadding = false
      }
    },

    normalizeAppointments(citas) {
      if (!Array.isArray(citas)) return []
      return citas.map(cita => this.normalizeCancelledAsFree(cita))
    },

    normalizeCancelledAsFree(cita) {
      if (!cita || cita.state !== 'user_cancelled') {
        return cita
      }

      return {
        ...cita,
        state: 'free',
        patient_name: '',
        nombre: '',
        lastname: '',
        telefono: '',
        phone: '',
        mobile: '',
        obra_social: '',
        insurance: '',
        insurance_name: '',
        ref: '',
        dni: '',
        party: null,
        patient: null,
        patient_id: null,
        title: ''
      }
    },

    handlerSobreturno() {
      this.sobreTurno = true
    },

    cancelarSobreturno() {
      this.sobreTurno = false
      // Restaurar valores por defecto de fecha y hora
      const now = new Date()
      this.date = now.toISOString().substr(0, 10)
      this.picker = now.getHours().toString().padStart(2, '0') + ':' + 
                    (Math.ceil(now.getMinutes() / 15) * 15).toString().padStart(2, '0')
      // Limpiar formulario de paciente (account_info es el que usa el form)
      this.account_info = {
        gender: 'MASCULINO',
        name: '',
        password: '',
        lastname: '',
        dni: '',
        roles: ['end_user'],
        dob: '',
        active: true,
        city: '',
        street: '',
        subdivision: '',
        insuranse: '',
        affiliate_number: '',
        telefono: '',
        mail: '',
        tipoDeConsulta: 'Consulta de seguimiento'
      }
      this.tipoConsultaPrevio = this.account_info.tipoDeConsulta
      // Limpiar pacienteForm también
      this.pacienteForm = {
        apellido: '',
        nombre: '',
        dni: '',
        telefono: '',
        email: ''
      }
    },

    async searchPaciente() {
      if (!this.account_info.dni) {
         this.$alert({ title: 'Atención', message: 'Ingrese un DNI para buscar', color: 'info' });
         return;
      }
      
      this.searchingPaciente = true;
      
      try {
        const resultado = await getPacienteUnificado(this.account_info.dni);
        
        if (resultado.success) {
           const data = resultado.data;
           
           let party = null;
           let contacto = {};
           let usuario = {};
           let direccion = {}; // Inicializar
           
           if (Array.isArray(data)) {
               // Estructura array: [paciente, direccion, contacto, usuario]
               const [pacienteData, direccionData, contactoData, usuarioData] = data;
               
               party = pacienteData.party || pacienteData;
               contacto = contactoData || {};
               usuario = usuarioData || {};
               direccion = direccionData || {}; // Asignar
           } else {
               // Estructura objeto simple
               party = data.party || data;
               contacto = data.contacto || {};
               usuario = data.usuario || {};
               direccion = data.direccion || {}; // Asignar
           }

           // Lógica unificada para extraer seguro
           let seguroData = null;
           if (Array.isArray(data)) {
                if (data[0] && data[0].seguro) seguroData = data[0].seguro;
           } else {
                if (data.seguro) seguroData = data.seguro;
           }
           
           if (party) {
             const nombre = party.name || party.rec_name || '';
             const apellido = party.lastname || '';
             
             // Actualizar campos individualmente para asegurar reactividad
             this.account_info.name = nombre;
             this.account_info.lastname = apellido;
             this.account_info.gender = party.gender || this.account_info.gender;
             
             // IMPORTANTE: Guardar el ID del paciente para vincularlo al reservar
             if (party.id) {
                this.account_info.id = party.id;
             } else if (data.id) {
                 this.account_info.id = data.id;
             }

             // Si viene telefono en contacto
             if (contacto && contacto.value) {
                this.account_info.telefono = contacto.value;
             }
             // Si viene email
             if (usuario && usuario.email) {
                this.account_info.mail = usuario.email;
             }
             
             // Cargar Dirección
             if (direccion) {
                this.account_info.street = direccion.street || '';
                this.account_info.city = direccion.city || '';
                if (direccion.provincia && direccion.provincia.id) {
                    this.account_info.subdivision = direccion.provincia.id;
                }
             }

             // Cargar Obra Social si existe en la respuesta
             if (seguroData && seguroData.empresa) {
                this.account_info.insuranse = seguroData.empresa.id;
             } else {
                this.account_info.insuranse = ""; // Limpiar si no tiene
             }

             if (seguroData && seguroData.number) {
                 this.account_info.affiliate_number = seguroData.number;
             } else {
                 this.account_info.affiliate_number = "";
             }
             
             // Forzar actualización de la vista
             this.$forceUpdate();
             
             this.$alert({ 
                 title: 'Paciente encontrado', 
                 message: `Datos cargados: ${nombre} ${apellido}`, 
                 color: 'success' 
             });
           }
        } else {
           this.$alert({ title: 'No encontrado', message: 'Paciente no encontrado. Ingrese los datos manualmente.', color: 'warning' });
        }
      } catch (error) {
        this.$alert({ title: 'Error', message: 'Error al buscar paciente', color: 'error' });
      } finally {
        this.searchingPaciente = false;
      }
    },

    async crearTurno() {
      
      if (!this.validarSobreturno) {
        alert('Complete todos los campos obligatorios (Nombre, Apellido, DNI, Fecha y Hora)')
        return
      }
      
      if (!this.selected) {
        alert('Seleccione un profesional')
        return
      }
      
      try {
        this.creandoSobreturno = true
        
        let idProfesional = get_profesional_id(this.selected, this.profesional, this.nombres)
        
        if (!idProfesional) {
          alert('Error: No se pudo encontrar el ID del profesional')
          return
        }
        
        // Formato de fecha
        const fecha = this.date + " " + this.picker
        const appointment_date = new Date(fecha)
        
        // Usar DNI del formulario (account_info)
        const dniPaciente = this.account_info.dni
        const nombrePaciente = this.account_info.name + ' ' + this.account_info.lastname
        const telefonoPaciente = this.account_info.telefono
        
        // Usar el nuevo API unificado
        const result = await crearSobreturno({
          profesional_id: idProfesional,
          paciente_dni: dniPaciente,
          paciente_nombre: nombrePaciente,
          paciente_telefono: telefonoPaciente,
          start: appointment_date,
          end: appointment_date,
          tipo_visita: this.account_info.tipoDeConsulta || 'Consulta de seguimiento'
        })
        
        if (result.success) {
          const actualizacionPaciente = await updatePaciente({
            ...this.account_info,
            tipoDeConsulta: undefined
          })

          if (actualizacionPaciente !== 200 && (this.account_info.insuranse || this.account_info.affiliate_number)) {
            this.$store.commit('showSnackbar', {
              text: 'El sobreturno se creó, pero no se pudo actualizar la cobertura del paciente.',
              color: 'warning'
            })
          }

          this.$store.commit('showSnackbar', { text: 'Sobreturno creado con éxito', color: 'success' })
          this.cancelarSobreturno()
          this.getAppointments()
        } else {
          alert('No se pudo crear el sobreturno: ' + (result.error || ''))
        }
      } catch (error) {
        alert('Error: ' + error.message)
      } finally {
        this.creandoSobreturno = false
      }
    },

    formatDateTime(dateTime) {
      if (!dateTime) return ''
      try {
        const date = new Date(dateTime)
        return date.toLocaleString('es-AR', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        })
      } catch (error) {
        return dateTime
      }
    },

    getStateColor(state) {
      const colors = {
        'free': 'green',
        'confirmed': 'blue',
        'checked_in': 'orange',
        'done': 'grey',
        'cancelled': 'red'
      }
      return colors[state?.toLowerCase()] || 'grey'
    },

    getStateText(state) {
      const texts = {
        'free': 'Libre',
        'confirmed': 'Confirmado',
        'checked_in': 'En Espera',
        'done': 'Terminado',
        'cancelled': 'Cancelado'
      }
      return texts[state?.toLowerCase()] || state
    },

    /**
     * Extrae el teléfono del paciente del turno
     */
    getPatientPhone(item) {
      // Intentar varias posibles ubicaciones del teléfono
      if (item.telefono) return item.telefono;
      if (item.phone) return item.phone;
      if (item.mobile) return item.mobile;
      
      // Puede venir en el campo 'title' como "Telefono:123456789 Obra Social:..."
      if (item.title && item.title.includes('Telefono:')) {
        const match = item.title.match(/Telefono:(\d+)/);
        if (match) return match[1];
      }
      
      // Buscar en el nombre si tiene formato especial
      if (item.nombre && item.nombre.includes('Telefono:')) {
        const match = item.nombre.match(/Telefono:(\d+)/);
        if (match) return match[1];
      }
      
      return null;
    },
    
    /**
     * Extrae la obra social del turno
     */
    getObraSocial(item) {
      if (item.obra_social) return item.obra_social;
      if (item.insurance) return item.insurance;
      if (item.insurance_name) return item.insurance_name;
      
      // Puede venir en el campo 'title' como "Telefono:123456789 Obra Social:OSDE"
      if (item.title && item.title.includes('Obra Social:')) {
        const match = item.title.match(/Obra Social:([^,]+)/);
        if (match) return match[1].trim();
      }
      
      // Buscar en el nombre si tiene formato especial
      if (item.nombre && item.nombre.includes('Obra Social:')) {
        const match = item.nombre.match(/Obra Social:([^,]+)/);
        if (match) return match[1].trim();
      }
      
      return null;
    },
    
    /**
     * Extrae el nombre completo del paciente del turno
     */
    getPatientName(item) {
      // Si tiene nombre y apellido separados
      if (item.nombre && item.lastname) {
        return `${item.nombre} ${item.lastname}`;
      }
      
      // Si solo tiene nombre
      if (item.nombre) return item.nombre;
      
      // Si tiene patient_name
      if (item.patient_name) return item.patient_name;
      
      // Si el nombre está en 'title'
      if (item.title) {
        let name = item.title;
        // Limpiar si tiene Telefono:
        if (name.includes('Telefono:')) {
           name = name.split('Telefono:')[0];
        }
        // Limpiar si tiene Obra Social:
        if (name.includes('Obra Social:')) {
           name = name.split('Obra Social:')[0];
        }
        name = name.trim();
        if (name.length > 0) return name;
      }
      
      // Si está en party.name o party.rec_name
      if (item.party) {
        if (item.party.name) {
          return item.party.lastname ? `${item.party.name} ${item.party.lastname}` : item.party.name;
        }
        if (item.party.rec_name) return item.party.rec_name;
      }
      
      return 'Sin nombre';
    },
    
    /**
     * Abre WhatsApp con el número de teléfono
     */
    openWhatsApp(phone) {
      if (!phone) return;
      
      // Limpiar el número de teléfono (solo dígitos)
      let cleanPhone = phone.replace(/\D/g, '');
      
      // Si no tiene código de país, agregar +54 (Argentina)
      if (!cleanPhone.startsWith('54')) {
        // Si empieza con 0, quitarlo
        if (cleanPhone.startsWith('0')) {
          cleanPhone = cleanPhone.substring(1);
        }
        cleanPhone = '54' + cleanPhone;
      }
      
      // Abrir WhatsApp
      const whatsappUrl = 'https://wa.me/' + cleanPhone;
      window.open(whatsappUrl, '_blank');
    },

    getProfessionalName(professionalId) {
      if (this.selected && (this.selected.id === professionalId || !professionalId)) {
          return this.selected.text || this.selected.name || 'No especificado';
      }
      if (!professionalId || !this.profesional) return 'No especificado'
      
      const professional = this.profesional.find(p => p.id === professionalId)
      return professional ? professional.name : `ID: ${professionalId}`
    },

    onDataPaciente(data) {
      this.account_info = data;
      if (!this.account_info.tipoDeConsulta) {
        this.account_info.tipoDeConsulta = this.tipoConsultaPrevio || 'Consulta de seguimiento'
      }
      this.tipoConsultaPrevio = this.account_info.tipoDeConsulta
      this.dialog2 = false;
    },

    onClosePacienteCard() {
      this.dialog2 = false;
      
      // Si cerramos el diálogo y todavía hay un cambio pendiente, significa que el usuario canceló.
      if (this.pendingStateChange) {
          this.pendingStateChange = null; 
      }
    },
    
    // Nuevo método para manejar la confirmación desde PacienteCard
    onPacienteConfirmed(status) {
      if (this.pendingStateChange) {
          const { turno, nuevoEstado } = this.pendingStateChange;
          
          // Ejecutar el cambio de estado real
          this.ejecutarCambioEstado(turno, nuevoEstado);
          
          // Limpiar pendiente
          this.pendingStateChange = null;
      }
    },

    reservarTurno(turno) {
      this.turnoSeleccionado = turno
      // Limpiar datos del paciente previos
      this.account_info = createEmptyAccountInfo()
      this.tipoConsultaPrevio = this.account_info.tipoDeConsulta
      this.dialogReserva = true
    },

    abrirPacienteCard() {
      this.dialog2 = true
    },

    cancelarReserva() {
      this.dialogReserva = false
      this.turnoSeleccionado = null
      this.account_info = createEmptyAccountInfo()
      this.tipoConsultaPrevio = this.account_info.tipoDeConsulta
    },

    async confirmarReserva() {
      if (!this.account_info.name || !this.account_info.dni) {
        alert('Debe seleccionar un paciente antes de confirmar la reserva')
        return
      }

      try {
        // Preparar payload asegurando IDs
        const payload = { ...this.account_info };
        if (payload.id && !payload.paciente_id) {
            payload.paciente_id = payload.id;
        }

        // Usar el nuevo API para reservar turno como secretaria
        const result = await reservarTurnoSecretaria(this.turnoSeleccionado.id, payload)
        
        if (result.success) {
          alert('Turno reservado con éxito')
          this.cancelarReserva()
          this.getAppointments()
        } else {
          alert('No se pudo confirmar la reserva: ' + (result.error || ''))
        }
      } catch (error) {
        console.error('❌ Error confirmando reserva:', error)
        alert('Error: ' + error.message)
      }
    },

    async cambiarEstado(turno, nuevoEstado) {
      // Interceptar cambio a 'checked_in' (En Espera)
      if (nuevoEstado === 'checked_in') {
          // Guardar el cambio pendiente
          this.pendingStateChange = { turno, nuevoEstado };
          
          // Obtener ID del paciente del turno de forma robusta
          let pacienteId = null;
          let pacienteDni = null;

          // 1. Intentar obtener ID de party
          if (turno.party) {
             if (typeof turno.party === 'object') {
                 pacienteId = turno.party.id;
                 pacienteDni = turno.party.ref || turno.party.dni;
             } else {
                 pacienteId = turno.party;
             }
          } 
          
          // 2. Intentar obtener ID de patient o patient_id
          if (!pacienteId) {
             if (turno.patient_id) pacienteId = turno.patient_id;
             else if (turno.patient) pacienteId = turno.patient;
          }

          // 3. Intentar obtener DNI del turno directo (dni o ref)
          if (!pacienteDni) {
              if (turno.dni) pacienteDni = turno.dni;
              else if (turno.ref) pacienteDni = turno.ref;
          }
          
          // 4. Lógica de fallback: Si no hay ID pero sí DNI, usar DNI
          // IMPORTANTE: DNI es preferible a veces porque el ID de party puede no coincidir con el ID de usuario en monolito
          if (pacienteDni) {
              this.paciente_id = pacienteDni;
          } else if (pacienteId) {
              this.paciente_id = pacienteId.toString();
          } else {
              this.paciente_id = "0";
              
              // Fallback extremo: usar nombre y apellido para pre-llenar aunque sea
              if (turno.nombre || turno.name) {
                  this.account_info.name = turno.nombre || turno.name || '';
                  this.account_info.lastname = turno.lastname || '';
              }
          }
          
          // Buscar datos actualizados del paciente antes de abrir
          if (this.paciente_id && this.paciente_id !== "0") {
             this.searchingPaciente = true;
             try {
                const resultado = await getPacienteUnificado(this.paciente_id);
                if (resultado.success) {
                   const data = resultado.data;
                   let party = null;
                   let contacto = {};
                   let usuario = {};
                   let direccion = {};
                   
                   if (Array.isArray(data)) {
                       const [pacienteData, direccionData, contactoData, usuarioData] = data;
                       party = pacienteData.party || pacienteData;
                       direccion = direccionData || {};
                       contacto = contactoData || {};
                       usuario = usuarioData || {};
                   } else {
                       party = data.party || data;
                       direccion = data.direccion || {};
                       contacto = data.contacto || {};
                       usuario = data.usuario || {};
                   }
                   
                   // Lógica unificada para extraer seguro
            let seguroData = null;
            if (Array.isArray(data)) {
                 if (data[0] && data[0].seguro) seguroData = data[0].seguro;
            } else {
                 if (data.seguro) seguroData = data.seguro;
            }
            
            if (party) {
                       this.account_info.name = party.name || '';
                       this.account_info.lastname = party.lastname || '';
                       this.account_info.dni = party.ref || this.account_info.dni;
                       this.account_info.gender = party.gender || 'm';
                       this.account_info.dob = party.dob || '';
                       
                       this.account_info.telefono = contacto.value || '';
                       this.account_info.mail = usuario.email || '';
                       
                       if (direccion) {
                           this.account_info.street = direccion.street || '';
                           this.account_info.city = direccion.city || '';
                           this.account_info.subdivision = direccion.provincia ? direccion.provincia.id : '';
                       }
                       
                       // Seguro
                        if (data[0] && data[0].seguro && data[0].seguro.empresa) { // Fix array structure assumptions
                            this.account_info.insuranse = data[0].seguro.empresa.id;
                        } else if (data.seguro && data.seguro.empresa) {
                            this.account_info.insuranse = data.seguro.empresa.id;
                        }
                   }
                }
             } catch (e) {
                 // Error fetching patient details for check-in
             } finally {
                 this.searchingPaciente = false;
             }
          }

          // Abrir dialogo interno
          this.dialogCheckIn = true;
          return;
      }
      
      // Si no es check-in, ejecutar directamente
      await this.ejecutarCambioEstado(turno, nuevoEstado);
    },

    async ejecutarCambioEstado(turno, nuevoEstado) {
      try {
        // Usar el nuevo API unificado
        const result = await cambiarEstadoTurno(turno.id, nuevoEstado)
        
        if (result.success) {
          const estadoTexto = this.getStateText(nuevoEstado)
          this.$store.commit('showSnackbar', { text: `Turno marcado como ${estadoTexto}`, color: 'success' })
          this.getAppointments()
        } else {
          alert('No se pudo cambiar el estado: ' + (result.error || ''))
        }
        
      } catch (error) {
        console.error('❌ Error cambiando estado:', error)
        alert('Error al cambiar estado: ' + error.message)
      }
    },

    async cancelarTurno(turno) {
      this.turnoParaCancelar = turno;
      this.selectedCancellationState = 'user_cancelled'; // Default
      this.dialogCancelar = true;
    },

    async confirmarCancelacion() {
        if (!this.turnoParaCancelar || !this.selectedCancellationState) return;
        
        try {
          this.dialogCancelar = false; // Cerrar dialogo antes de procesar para mejor UX o mostrar loading
          
          const result = await cambiarEstadoTurno(this.turnoParaCancelar.id, this.selectedCancellationState)
          
          if (result.success) {
            this.$store.commit('showSnackbar', { text: 'Turno cancelado exitosamente', color: 'success' })
            this.getAppointments()
          } else {
            alert('Error al cancelar: ' + (result.error || ''))
          }
          
        } catch (error) {
          console.error('❌ Error cancelando turno:', error)
          alert('Error al cancelar turno: ' + error.message)
        } finally {
            this.turnoParaCancelar = null;
        }
    },

    cancelarCheckIn() {
        this.dialogCheckIn = false;
        // Si cerramos el diálogo y todavía hay un cambio pendiente, significa que el usuario canceló.
       if (this.pendingStateChange) {
          this.pendingStateChange = null; 
       }
    },

    async confirmarCheckIn() {
        if (!this.account_info.name || !this.account_info.lastname || !this.account_info.dni) {
             this.$alert({ title: 'Error', message: 'Nombre, Apellido y DNI son obligatorios', color: 'error' });
             return;
        }

        this.checkInLoading = true;
        try {
            // 1. Guardar/Actualizar Paciente
            const updateResult = await updatePaciente(this.account_info);

          if (!(updateResult === 200 || updateResult?.success)) {
            this.$alert({ title: 'Error', message: 'No se pudo actualizar los datos del paciente antes de iniciar el turno', color: 'error' });
            return;
            }

            // 2. Ejecutar cambio de estado
            if (this.pendingStateChange) {
                const { turno, nuevoEstado } = this.pendingStateChange;
                await this.ejecutarCambioEstado(turno, nuevoEstado);
                this.pendingStateChange = null;
            }

            this.dialogCheckIn = false;
            this.$alert({ title: 'Éxito', message: 'Paciente actualizado y Turno iniciado', color: 'success' });

        } catch (error) {
            console.error('❌ Error in check-in flow:', error);
             this.$alert({ title: 'Error', message: 'Error durante el proceso: ' + error.message, color: 'error' });
        } finally {
            this.checkInLoading = false;
        }
    }
  }
}
</script>

<style scoped>
.mt-3 { 
  margin-top: 12px; 
}
.mt-4 { 
  margin-top: 16px; 
}

/* Sobreturno Dialog Styles */
.sobreturno-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.sobreturno-card .v-card__title.primary {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  font-size: 1.25rem;
  font-weight: 500;
}

.sobreturno-card .v-card__text {
  background-color: #fafafa;
  max-height: 70vh;
  overflow-y: auto;
}

.sobreturno-card .section-title {
  display: flex;
  align-items: center;
  color: #424242;
  font-size: 0.95rem;
}

.sobreturno-card .v-text-field.v-text-field--outlined {
  border-radius: 8px;
}

.sobreturno-card .v-date-picker,
.sobreturno-card .v-time-picker {
  border-radius: 8px !important;
}

.sobreturno-card .v-tabs {
  background: transparent;
}

.sobreturno-card .v-tab {
  text-transform: none;
  font-weight: 500;
}

.sobreturno-card .v-card__actions {
  background-color: #f5f5f5;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .sobreturno-card .v-card__title.primary {
    padding: 12px 16px !important;
    font-size: 1.1rem;
  }
  
  .sobreturno-card .v-card__text {
    padding: 16px !important;
    max-height: 60vh;
  }
  
  .sobreturno-card .section-title {
    font-size: 0.9rem;
  }
  
  .sobreturno-card .v-card__actions {
    padding: 12px 16px !important;
  }
  
  .sobreturno-card .v-card__actions .v-btn {
    font-size: 0.85rem;
  }
}

/* Mejoras para tablets */
@media (min-width: 600px) and (max-width: 960px) {
  .sobreturno-card .v-date-picker,
  .sobreturno-card .v-time-picker {
    max-width: 100%;
  }
}

/* WhatsApp button in table */
.whatsapp-btn {
  color: #25D366 !important;
}

.whatsapp-btn:hover {
  background-color: rgba(37, 211, 102, 0.1) !important;
}

/* Table improvements */
.v-data-table td {
  padding: 8px 16px !important;
}

.v-data-table .v-chip {
  font-size: 0.75rem;
}

/* Estado chips con colores */
.estado-libre {
  background-color: #4CAF50 !important;
  color: white !important;
}

.estado-reservado {
  background-color: #2196F3 !important;
  color: white !important;
}

.estado-confirmado {
  background-color: #9C27B0 !important;
  color: white !important;
}

.estado-cancelado {
  background-color: #f44336 !important;
  color: white !important;
}

.estado-completado {
  background-color: #607D8B !important;
  color: white !important;
}
</style>
